import { supabase } from "@/shared/lib/supabase";

export function notifyOnboardingBooked(eventUri: string, inviteeUri: string): void {
  supabase.functions
    .invoke("communications/attorney-onboarding-booked", {
      body: { event_uri: eventUri, invitee_uri: inviteeUri },
    })
    .then(({ error }) => {
      if (error) console.error("Attorney onboarding notification failed:", error);
    })
    .catch(console.error);
}
